var pageName = function () {
    var str = location.pathname.split("/"), _pagename = [];
    for (i in str) {
        if (str[i]) {
            _pagename.push(str[i]);
        }
    }
    if (_pagename.length) {
        return _pagename.join(':');
    }
    return "Home";
};

var contentType = function () {
    var str = location.pathname.split("/")[1];
    var str_1 = location.pathname.split("/")[2];
    if (str_1) {
        return ("home sección");
    } else if (str != '') {
        return ("home sección");
    } else {
        return ("home general");
    }
};

var weekday = function () {
    var d = new Date();
    if (d.getDay() == 6 || d.getDay() == 0) {
        return 'Weekend';
    } else {
        return 'Weekday';
    }
};

var day = function () {
    var d = new Date();
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    return weekday[d.getDay()];
};

var hour = function () {
    var date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
};

var referrer = function () {
    return document.referrer;
};

var channel = function () {
    var str = location.pathname.split("/")[1];
    if (str != '') {
        return (str);
    } else {
        return ("Home");
    }
};

var digitalData = digitalData || {};
digitalData = {
    page: {
        pageName: pageName(),
        channel: channel(),
        day: day(),
        hour: hour(),
        weekday: weekday(),
        referrer: referrer(),
        contentType: contentType()
    }
};
